import { SearchFilterResultTypeBlueprint } from '@backstage/plugin-search-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { RiFileTextFill, RiShapesFill } from '@remixicon/react';

/**
 * Software Catalog Search Filter
 *
 * for the SearchFilterBlueprint we follow the naming convention for "name":
 * <result-type>-filter-<filter-variant>
 *
 * for the createSearchFilter({}) calls, we follow the naming convention for "displayName":
 * <result-type>-filter-<filter-variant>
 *
 */
export const softwareCatalogSearchFilterType: ExtensionDefinition =
  SearchFilterResultTypeBlueprint.make({
    name: 'software-catalog',
    params: {
      value: 'software-catalog',
      name: 'Software Catalog',
      icon: <RiShapesFill />,
    },
  });

/**
 * TechDocs Search Filter
 *
 * for the SearchFilterBlueprint we follow the naming convention for "name":
 * <result-type>-filter-<filter-variant>
 *
 * for the createSearchFilter({}) calls, we follow the naming convention for "displayName":
 * <result-type>-filter-<filter-variant>
 *
 */
export const techdocsSearchFilterType: ExtensionDefinition =
  SearchFilterResultTypeBlueprint.make({
    name: 'techdocs',
    params: {
      value: 'techdocs',
      name: 'TechDocs',
      icon: <RiFileTextFill />,
    },
  });
